import { API_URL } from "../../config";
import { extractMongoObjectIdHex } from "../../utils/helpers";

/**
 * @param {object} params
 * @param {string} params.apiUrl
 * @param {string} params.cursoId
 * @returns {Promise<{ ok: true, curso: object } | { ok: false, error: string }>}
 */
export async function duplicarCursoAdmin({ apiUrl = API_URL, cursoId }) {
  const id = extractMongoObjectIdHex(cursoId);
  if (!id) {
    return { ok: false, error: "Identificador de curso inválido." };
  }

  let res;
  try {
    res = await fetch(`${apiUrl}/api/admin/cursos/${id}/duplicar`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });
  } catch {
    return { ok: false, error: "No se pudo conectar con el servidor." };
  }

  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    const msg =
      data && typeof data.error === "string" ? data.error : `Error al duplicar (${res.status})`;
    return { ok: false, error: msg };
  }

  return { ok: true, curso: data?.curso ?? null };
}
